// @flow
import * as React from 'react';
import EditIcon from 'esm-web-pro/components/layout/sidePanel/icons/EditIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import DeleteIcon from 'esm-web-pro/components/layout/sidePanel/icons/DeleteIcon';
import { IntlShape } from 'react-intl';
import MainActions from 'esm-web-pro/components/layout/sidePanel/MainActions';

type Props = {
    updatingObject: Object,
    intl: IntlShape,
    loading: boolean,
    editor: Class,
    handleDeleteClick: Function,
    resource: Object,
};
// eslint-disable-next-line react/prefer-stateless-function
class MapActions extends React.Component <Props> {
    getActions = () => {
        const {
            intl: { formatMessage }, updatingObject, loading, editor, handleDeleteClick, resource,
        } = this.props;

        const handleClickedEditBtn = (e) => {
            updatingObject.layer.pm.enable({
                allowSelfIntersection: false,
            });
            // editor.setDrawing(true);
            editor.handleEditLayerClick(updatingObject.resource, updatingObject.layer, e);
        };

        return [
            {
                key: 'point11-edit',
                icon: <EditIcon size="small" />,
                disabled: loading || !resource.allowEdit,
                callback: (e) => handleClickedEditBtn(e),
                tooltip: formatMessage(actionMessages.edit),
                color: 'transparent',
                marginVertical: '15px',
                radius: '0%',
            },
            {
                key: 'point11-delete',
                icon: <DeleteIcon size="small" />,
                disabled: loading || !resource.allowDelete,
                callback: (e) => handleDeleteClick(e),
                tooltip: formatMessage(actionMessages.delete),
                color: 'transparent',
                marginVertical: '15px',
                radius: '0%',
            },
        ];
    };

    render() {
        return (
            <MainActions main actions={this.getActions()} />
        );
    }
}

export default MapActions;
